(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-rotativo"] && !Shopify.designMode) return;
  try {
    
  class BannerRotativo extends HTMLElement {
    connectedCallback() {
      this.trilho = this.querySelector('.br__trilho');
      this.slides = Array.from(this.querySelectorAll('.br__slide'));
      this.pontos = Array.from(this.querySelectorAll('.br__ponto'));
      this.atual = 0;
      if (!this.trilho || this.slides.length < 2) return;

      this.querySelector('.br__seta--ant')?.addEventListener('click', () => this.ir(this.atual - 1));
      this.querySelector('.br__seta--prox')?.addEventListener('click', () => this.ir(this.atual + 1));
      this.pontos.forEach((ponto, i) => ponto.addEventListener('click', () => this.ir(i)));

      this.trilho.addEventListener(
        'scroll',
        () => {
          clearTimeout(this.espera);
          this.espera = setTimeout(() => {
            const largura = this.trilho.clientWidth || 1;
            this.marcar(Math.round(this.trilho.scrollLeft / largura));
          }, 80);
        },
        { passive: true }
      );

      this.addEventListener('shopify:block:select', (evento) => {
        const i = this.slides.indexOf(evento.target);
        if (i > -1) this.ir(i);
      });

      this.marcar(0);

      const segundos = parseInt(this.dataset.intervalo, 10);
      const reduzir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const editor = window.Shopify && window.Shopify.designMode;
      if (segundos > 0 && !reduzir && !editor) {
        this.pausado = false;
        this.timer = setInterval(() => {
          if (!this.pausado && !document.hidden) this.ir(this.atual + 1);
        }, segundos * 1000);
        this.addEventListener('mouseenter', () => (this.pausado = true));
        this.addEventListener('mouseleave', () => (this.pausado = false));
        this.addEventListener('focusin', () => (this.pausado = true));
        this.addEventListener('focusout', () => (this.pausado = false));
        this.addEventListener('touchstart', () => (this.pausado = true), { passive: true });
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    ir(indice) {
      const total = this.slides.length;
      const i = ((indice % total) + total) % total;
      this.trilho.scrollTo({ left: i * this.trilho.clientWidth, behavior: 'smooth' });
      this.marcar(i);
    }

    marcar(i) {
      this.atual = i;
      this.pontos.forEach((ponto, k) => ponto.setAttribute('aria-current', k === i ? 'true' : 'false'));
    }
  }

  if (!customElements.get('banner-rotativo')) {
    customElements.define('banner-rotativo', BannerRotativo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contador-oferta"] && !Shopify.designMode) return;
  try {
    
  class ContadorOferta extends HTMLElement {
    connectedCallback() {
      this.fim = this.lerData(this.dataset.fim);
      this.relogio = this.querySelector('.co__relogio');
      this.partes = {};
      this.querySelectorAll('[data-parte]').forEach((el) => (this.partes[el.dataset.parte] = el));
      const editor = window.Shopify && window.Shopify.designMode;

      if (!this.fim) {
        if (this.relogio) this.relogio.hidden = true;
        const aviso = this.querySelector('[data-aviso="invalida"]');
        if (aviso) aviso.hidden = false;
        else if (!editor) this.hidden = true;
        return;
      }

      this.atualizar();
      this.timer = setInterval(() => this.atualizar(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    lerData(bruto) {
      let texto = (bruto || '').trim().replace(' ', 'T');
      if (!texto) return null;
      if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) texto += 'T23:59';
      if (/T\d{2}:\d{2}$/.test(texto)) texto += ':00';
      if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(texto)) texto += '-03:00';
      const data = new Date(texto);
      return isNaN(data.getTime()) ? null : data;
    }

    atualizar() {
      const restante = this.fim.getTime() - Date.now();
      if (restante <= 0) {
        clearInterval(this.timer);
        this.terminar();
        return;
      }
      const s = Math.floor(restante / 1000);
      const valores = {
        dias: Math.floor(s / 86400),
        horas: Math.floor((s % 86400) / 3600),
        minutos: Math.floor((s % 3600) / 60),
        segundos: s % 60,
      };
      Object.entries(valores).forEach(([parte, valor]) => {
        if (this.partes[parte]) this.partes[parte].textContent = String(valor).padStart(2, '0');
      });
    }

    terminar() {
      const editor = window.Shopify && window.Shopify.designMode;
      if (this.dataset.aoTerminar === 'ocultar' && !editor) {
        this.hidden = true;
        return;
      }
      if (this.relogio) this.relogio.hidden = true;
      const aviso = this.querySelector('[data-aviso="fim"]');
      if (aviso) aviso.hidden = false;
    }
  }

  if (!customElements.get('contador-oferta')) {
    customElements.define('contador-oferta', ContadorOferta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vistos-recentemente"] && !Shopify.designMode) return;
  try {
    
  class VistosRecentemente extends HTMLElement {
    static chave = 'vistos-recentemente';

    connectedCallback() {
      const atual = this.dataset.atual;
      const lista = this.ler();
      if (atual) this.gravar([atual, ...lista.filter((h) => h !== atual)].slice(0, 12));
      const mostrar = lista.filter((h) => h && h !== atual).slice(0, parseInt(this.dataset.limite, 10) || 4);
      if (mostrar.length) this.renderizar(mostrar);
    }

    ler() {
      try {
        const bruto = JSON.parse(localStorage.getItem(VistosRecentemente.chave) || '[]');
        return Array.isArray(bruto) ? bruto : [];
      } catch (erro) {
        return [];
      }
    }

    gravar(lista) {
      try {
        localStorage.setItem(VistosRecentemente.chave, JSON.stringify(lista));
      } catch (erro) {
        /* navegador sem armazenamento: ignora */
      }
    }

    formatar(centavos) {
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: this.dataset.moeda || 'BRL' }).format(centavos / 100);
      } catch (erro) {
        return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
      }
    }

    parcelamento(centavos) {
      const maximo = parseInt(this.dataset.maxParcelas, 10) || 12;
      const minimo = Math.max(1, Math.round((parseFloat(this.dataset.parcelaMinima) || 0) * 100));
      const parcelas = Math.min(maximo, Math.floor(centavos / minimo));
      if (parcelas < 2) return '';
      const juros = (parseFloat(this.dataset.juros) || 0) / 100;
      let valor;
      if (juros > 0) {
        const fator = Math.pow(1 + juros, parcelas);
        valor = Math.round((centavos * juros * fator) / (fator - 1));
      } else {
        valor = Math.round(centavos / parcelas);
      }
      const prefixo = this.dataset.prefixo ? this.dataset.prefixo + ' ' : '';
      return prefixo + parcelas + 'x de ' + this.formatar(valor) + (juros > 0 ? '' : ' sem juros');
    }

    async renderizar(handles) {
      const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const respostas = await Promise.all(
        handles.map((handle) =>
          fetch(raiz + 'products/' + encodeURIComponent(handle) + '.js')
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      );
      const produtos = respostas.filter(Boolean);
      if (!produtos.length) return;

      const container = this.querySelector('.vr__lista');
      container.textContent = '';
      produtos.forEach((p) => container.appendChild(this.card(p)));
      this.hidden = false;
    }

    card(p) {
      const a = document.createElement('a');
      a.className = 'vr__card';
      a.href = p.url;
      a.setAttribute('role', 'listitem');

      const imagem = document.createElement('span');
      imagem.className = 'vr__imagem';
      if (p.featured_image) {
        const img = document.createElement('img');
        const url = p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image;
        img.src = url + (url.includes('?') ? '&' : '?') + 'width=500';
        img.alt = p.title;
        img.loading = 'lazy';
        img.width = 500;
        img.height = 500;
        imagem.appendChild(img);
      }
      a.appendChild(imagem);

      if (p.compare_at_price && p.compare_at_price > p.price) {
        const selo = document.createElement('span');
        selo.className = 'vr__selo';
        selo.textContent = '-' + Math.round(((p.compare_at_price - p.price) * 100) / p.compare_at_price) + '%';
        a.appendChild(selo);
      }

      const nome = document.createElement('span');
      nome.className = 'vr__nome';
      nome.textContent = p.title;
      a.appendChild(nome);

      const precos = document.createElement('span');
      precos.className = 'vr__precos';
      const preco = document.createElement('span');
      preco.className = 'vr__preco';
      preco.textContent = this.formatar(p.price);
      precos.appendChild(preco);
      if (p.compare_at_price && p.compare_at_price > p.price) {
        const antigo = document.createElement('s');
        antigo.className = 'vr__antigo';
        antigo.textContent = this.formatar(p.compare_at_price);
        precos.appendChild(antigo);
      }
      a.appendChild(precos);

      const textoParcelas = this.parcelamento(p.price);
      if (textoParcelas) {
        const parcelas = document.createElement('span');
        parcelas.className = 'vr__parcelas';
        parcelas.textContent = textoParcelas;
        a.appendChild(parcelas);
      }
      return a;
    }
  }

  if (!customElements.get('vistos-recentemente')) {
    customElements.define('vistos-recentemente', VistosRecentemente);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visual-loja"] && !Shopify.designMode) return;
  try {
    
  class NeveNatal extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (this.dataset.somenteDesktop === 'true' && window.matchMedia('(max-width: 749px)').matches) return;

      this.canvas = document.createElement('canvas');
      this.canvas.className = 'neve__canvas';
      this.canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(this.canvas);
      this.ctx = this.canvas.getContext('2d');
      this.cor = this.dataset.cor || '#ffffff';
      this.quantidade = Math.min(150, Math.max(5, parseInt(this.dataset.quantidade, 10) || 40));

      this.redimensionar = this.redimensionar.bind(this);
      this.desenhar = this.desenhar.bind(this);
      window.addEventListener('resize', this.redimensionar, { passive: true });
      this.redimensionar();
      this.flocos = Array.from({ length: this.quantidade }, () => this.novoFloco(true));
      this.quadro = requestAnimationFrame(this.desenhar);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.quadro);
      window.removeEventListener('resize', this.redimensionar);
      this.canvas?.remove();
    }

    redimensionar() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.largura = window.innerWidth;
      this.altura = window.innerHeight;
      this.canvas.width = this.largura * dpr;
      this.canvas.height = this.altura * dpr;
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    novoFloco(inicio) {
      return {
        x: Math.random() * this.largura,
        y: inicio ? Math.random() * this.altura : -8,
        raio: 1 + Math.random() * 2.4,
        velocidade: 0.25 + Math.random() * 0.8,
        fase: Math.random() * Math.PI * 2,
        opacidade: 0.45 + Math.random() * 0.5,
      };
    }

    desenhar() {
      if (!document.hidden) {
        const ctx = this.ctx;
        ctx.clearRect(0, 0, this.largura, this.altura);
        ctx.fillStyle = this.cor;
        ctx.strokeStyle = 'rgba(150, 130, 90, 0.18)';
        ctx.lineWidth = 0.6;
        for (const floco of this.flocos) {
          floco.y += floco.velocidade;
          floco.fase += 0.012;
          floco.x += Math.sin(floco.fase) * 0.35;
          if (floco.y > this.altura + 8) Object.assign(floco, this.novoFloco(false));
          ctx.globalAlpha = floco.opacidade;
          ctx.beginPath();
          ctx.arc(floco.x, floco.y, floco.raio, 0, Math.PI * 2);
          ctx.fill();
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }
      this.quadro = requestAnimationFrame(this.desenhar);
    }
  }

  if (!customElements.get('neve-natal')) {
    customElements.define('neve-natal', NeveNatal);
  }

  } catch(e) { console.error(e); }
})();
})();
